import { Box, Button, Drawer, List, ListItem, ListItemButton, ListItemText, Typography } from "@mui/material";
import FullLogo from "../assets/Full Logo - Light Transparent.png";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";



const LogoHomeButton = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '230px',

            cursor: 'pointer',

            '@media (max-width: 1000px)': {
                width: '100px',
            },
        }} onClick={ () => navigate('/') }>
            <img src={FullLogo} width={193} height={36} />
        </Box>
    );
};

const ExpandedNavigationItems = () => {
    const navigate = useNavigate();
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '32px',
            justifyContent: 'space-between',
            alignItems: 'center',

            '@media (max-width: 1000px)': {
                display: 'none'
            },
        }}>
            <Button variant="text" sx={{
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '16px',
                color: '#1e1559'
            }} onClick={ () => navigate('/') }>Home</Button>
            <Button variant="text" sx={{
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '16px',
                color: '#1e1559'
            }} onClick={ () => navigate('/about') }>About</Button>
            {/* <Button variant="text" sx={{
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '16px',
                color: '#1e1559'
            }} onClick={ () => navigate('/products') }>Products</Button> */}
            <Button variant="text" sx={{
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '16px',
                color: '#1e1559'
            }} onClick={ () => navigate('/contact-us') }>Contact Us</Button>
        </Box>
    );
};

const CollapsedNavigationItems = () => {
    const [ isOpen, setIsOpen ] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100px',

            '@media (min-width: 1001px)': {
                display: 'none'
            },
        }}>
            <Button variant="contained" sx={{
                backgroundColor: '#1e1559',
                color: '#fff',
                fontFamily: 'Red Rose',
                textTransform: 'none',
                fontWeight: '600',
                fontSize: '16px',
                borderRadius: '5px',
                padding: '5px 20px',
                boxShadow: 'none',
            }} onClick={ () => setIsOpen(!isOpen) }>Menu</Button>

            <Drawer anchor="right" open={isOpen} onClose={() => setIsOpen(false)} onClick={() => setIsOpen(false)}>
                <Box sx={{ width: 250, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', paddingLeft: '16px' }}>
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton onClick={ () => navigate('/') }>
                                <ListItemText primaryTypographyProps={{ sx: {
                                    fontFamily: 'Red Rose',
                                    fontWeight: (!location.pathname || location.pathname === "/") ? '600' : '400',
                                    fontSize: '16px',
                                    color: '#1e1559'
                                }}} primary="Home" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={ () => navigate('/about') }>
                                <ListItemText primaryTypographyProps={{ sx: {
                                    fontFamily: 'Red Rose',
                                    fontWeight: location.pathname === "/about" ? '600' : '400',
                                    fontSize: '16px',
                                    color: '#1e1559'
                                }}} primary="About" />
                            </ListItemButton>
                        </ListItem>
                        {/* <ListItem disablePadding>
                            <ListItemButton onClick={ () => navigate('/products') }>
                                <ListItemText primaryTypographyProps={{ sx: {
                                    fontFamily: 'Red Rose',
                                    fontWeight: location.pathname === "/products" ? '600' : '400',
                                    fontSize: '16px',
                                    color: '#1e1559'
                                }}} primary="Products" />
                            </ListItemButton>
                        </ListItem> */}
                        <ListItem disablePadding>
                            <ListItemButton onClick={ () => navigate('/contact-us') }>
                                <ListItemText primaryTypographyProps={{ sx: {
                                    fontFamily: 'Red Rose',
                                    fontWeight: location.pathname === "/contact-us" ? '600' : '400',
                                    fontSize: '16px',
                                    color: '#1e1559'
                                }}} primary="Contact Us" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </Box>
    );
};


const WebsiteNavigation = () => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            maxWidth: '1300px',
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        }}>
            {/* Logo */}
            <LogoHomeButton />

            {/* Expanded Navigation Items */}
            <ExpandedNavigationItems />

            {/* Box for padding to center the navigation items */}
            <Box width="230px" />
            <CollapsedNavigationItems />
        </Box>
    );
};


export default () => (
    <Box sx={{
        position: 'sticky',
        top: 0,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingLeft: '35px',
        paddingRight: '35px',
        height: '70px',
        backgroundColor: '#EBEEF3',
        zIndex: 1000,
    }}>
        <WebsiteNavigation />
    </Box>
);